'use client';

import { createContext } from 'react';

// Holds server-evaluated PostHog feature flag values for a subtree. `undefined`
// means no provider is present; an empty object means the provider is present
// but no flags were seeded for this request.
const PostHogFeatureFlagsContext = createContext(undefined);

export default PostHogFeatureFlagsContext;
